export enum CarouselAction {
  PROGRESS = "PROGRESS"
}
